<template>
	<div>
		<div class="relative flex space-x-2 items-center" :data-length="blobs.length">
			<div v-if="sources.length" class="flex space-x-2 items-center ">
				<label v-for="(url,index) in sources" class="block relative w-8 h-8">
					<div v-if="Urls.isVideo(url)"
						 class="w-8 h-8 rounded-full flex items-center justify-center bg-gray-500/50 overflow-hidden">
						<svg class="text-white w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
							 fill="currentColor" viewBox="0 0 16 16">
							<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
							<path
								d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>
						</svg>
					</div>
					<img v-else :src="url"
						 class="border border-slate-500 absolute inset-0 object-cover object-center w-8 h-8 rounded-full overflow-hidden"/>
					<div @click.prevent="removeImage(index)"
						 class="text-xs leading-none text-center rounded-full w-3 h-3 bg-red-500 text-white absolute -top-0.5 -right-0.5 cursor-pointer">
						&times;
					</div>
				</label>
			</div>

			<div v-if="sources.length < max">
				<label class="block relative w-8 h-8">
					<div
						class="cursor-pointer rounded-full flex items-center justify-center w-8 h-8 hover:bg-gray-100 dark:hover:bg-slate-600">
						<svg class="w-4 h-4 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
							 viewBox="0 0 16 16">
							<path
								d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V3zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>
						</svg>
					</div>
					<input @change="readURL" multiple class="hidden" type="file" accept="video/mp4, video/x-m4v, video/mov, video/webm, image/png, image/jpeg, image/webp, image/gif, image/jpg"/>
				</label>
			</div>

			<svg v-if="loading" aria-hidden="true"
				 class="absolute inset-0 opacity-50 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
				 viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
					fill="currentColor"/>
				<path
					d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
					fill="currentFill"/>
			</svg>
		</div>
	</div>

</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import Urls from "../../js/modules/Urls";
import ImageCompressor from "../../js/modules/ImageCompressor";
import AnimatedGif from "../../js/modules/AnimatedGif";

export default {
	computed: {
		Urls() {
			return Urls
		}
	},
	props: [
		'modelValue',
		'blobs',
	],
	data() {
		let sources = [];
		if (this.modelValue) {
			this.modelValue.forEach(src => {
				if (src.match(/^data:image/) || src.match(/^data:video/) || src.match(/^http/)) {
					sources.push(src);
				}
			});
		}
		return {
			max: 3,
			sources: sources,
			images: this.modelValue ?? [],
			loading: false,
		}
	},
	updated() {
		if (this.sources.length && this.images.length && !this.modelValue.length) {
			this.images = [];
			this.sources = [];
		}

		if (this.blobs.length && this.images.length < this.max) {
			let blobs = this.blobs;
			let onLoaded = () => {
				if (blobs.length) {
					let blob = blobs.pop();
					if (blob) {
						this.loadFromBlob(blob, onLoaded);
					}
				} else {
					this.$emit('update:modelValue', this.images);
				}
			};
			onLoaded();
		}
	},
	methods: {
		removeImage(index) {
			if (this.images[index]) {
				this.images.splice(index, 1);
			}
			if (this.sources[index]) {
				this.sources.splice(index, 1);
			}
			this.$emit('update:modelValue', this.images);
		},
		readURL(event) {
			let input = event.target;
			if (input.files) {
				let processed = 0;
				Array.from(input.files).forEach(file => {
					let isImage = file.type.indexOf("image") !== -1;
					let isVideo = file.type.indexOf("video") !== -1;
					if ((isImage || isVideo) && processed < this.max) {
						this.loadFromBlob(file);
						processed++;
					}
				})
			}
		},
		imageIsLoaded(blob, onLoadCallback) {
			this.loading = true;

			let reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onloadend = result => this.sendImage(reader, onLoadCallback);
		},
		async loadFromBlob(file, onLoadCallback) {
			const isImage = file.type.indexOf("image") !== -1;
			const isAnimatedGif = file.type === 'image/gif' && await AnimatedGif(file);
			const isHeic = file.type === 'image/heic' || file.type === 'image/heif';

			if (isImage && !isAnimatedGif && !isHeic) {
				ImageCompressor
					.compress(file, 1600, 1600, this.imageIsLoaded, err => console.log(err))
			} else {
				this.imageIsLoaded(file, onLoadCallback)
			}
		},
		sendImage(reader, onLoadCallback) {

			// Отправляем картинку на сервер
			const headers = {headers: {'Content-Type': reader.type}};

			Client.post('/api/v1.1/image/temp', {image: reader.result}, headers)
				.then(response => {
					// Успешно загрузили
					// кладем название картинки в массив значений картинок
					this.images.push(response.data.file.id);

					this.sources.push(response.data.file.url);

					// Обрезаем лишние значения картинок и источников
					this.images = this.images.slice(0, this.max);
					this.sources = this.sources.slice(0, this.max);

					if (onLoadCallback) {
						onLoadCallback.call(this);
					} else {
						this.$emit('update:modelValue', this.images);
					}

					this.loading = false;
				})
				.catch(error => {
					this.loading = false;
					// не удалось загрузить
					// удаляем загружаемую картинку из массива источников картинок
					// this.sources = this.sources.filter(url => {
					//     return url !== img;
					// })
					notify({
						type: 'error',
						text: error.response.data.message || 'Ошибка загрузки',
					});
				});
		},
	},
}
</script>
